import React from 'react';
import styles from './badge.module.scss';
import cx from 'classnames';

export type TBadgeColor = 'warning' | 'success' | 'info' | 'error';

type Props = {
  label: string;
  color: TBadgeColor;
  className?: string;
};
const Badge = (props: Props) => {
  const { label, color, className } = props;

  const classNames = cx(styles.badge, styles[color], className);

  return <div className={classNames}>{label}</div>;
};

export default Badge;
